import { useQueryClient } from "@tanstack/react-query";

import { JobQueryParams, JobUpdate, JobTrackerResponse } from "@/types";

export const useAddJobUpdate = () => {
  const queryClient = useQueryClient();

  return ({
    jobId,
    jobQueryParams,
    newJobUpdate,
  }: {
    jobId: string;
    jobQueryParams: JobQueryParams;
    newJobUpdate: JobUpdate;
  }) => {
    queryClient.setQueryData(
      ["jobs", jobQueryParams],
      (cachedJobs: JobTrackerResponse[]) => {
        return cachedJobs.map((job) => {
          if (job.jobId === jobId) {
            return {
              ...job,
              jobUpdates: [newJobUpdate, ...job.jobUpdates],
            };
          }
          return job;
        });
      },
    );
  };
};
